import YesNoQuestionPage from "@components/YesNoQuestionPage"
import { isHomeDesignFlow } from "@helpers/localStorage"

export default function ExperimentingLookPage() {
  if (isHomeDesignFlow()) {
    return <YesNoQuestionPage translationKey="experimentingLookHomeDesign" />
  }
  return <YesNoQuestionPage translationKey="experimentingLook" />
}
